var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "company-information-form" },
    [
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.legal_information.country_label"
            ),
            required: true,
            orientation: "horizontal"
          }
        },
        [
          _c(
            "CompassSelect",
            {
              attrs: { filterable: true },
              model: {
                value: _vm.selectedCountry,
                callback: function($$v) {
                  _vm.selectedCountry = $$v
                },
                expression: "selectedCountry"
              }
            },
            _vm._l(_vm.countries, function(item) {
              return _c("CompassDropdownSelectOption", {
                key: item.code,
                attrs: {
                  label: item.name,
                  value: item.code,
                  flag: item.code.toLowerCase(),
                  type: "flag"
                }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.showSirenSearchBar
        ? _c("SirenSearchBar", { on: { select: _vm.handleResultSelected } })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.legal_information.siren_label"
            ),
            required: true,
            orientation: "horizontal"
          }
        },
        [
          _c("CompassInput", {
            model: {
              value: _vm.siren,
              callback: function($$v) {
                _vm.siren = $$v
              },
              expression: "siren"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.legal_information.siret_label"
            ),
            required: true,
            orientation: "horizontal"
          }
        },
        [
          _c("CompassInput", {
            model: {
              value: _vm.siret,
              callback: function($$v) {
                _vm.siret = $$v
              },
              expression: "siret"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.legal_information.company_name_label"
            ),
            required: true,
            orientation: "horizontal"
          }
        },
        [
          _c("CompassInput", {
            model: {
              value: _vm.companyName,
              callback: function($$v) {
                _vm.companyName = $$v
              },
              expression: "companyName"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.legal_information.vat_number_label"
            ),
            required: true,
            orientation: "horizontal"
          }
        },
        [
          _c("CompassInput", {
            attrs: { disabled: _vm.isVatExempt },
            model: {
              value: _vm.vatNumber,
              callback: function($$v) {
                _vm.vatNumber = $$v
              },
              expression: "vatNumber"
            }
          }),
          _vm._v(" "),
          _c("CompassCheckbox", {
            staticClass: "company-information-form__vat-exempt-checkbox",
            attrs: {
              modelValue: false,
              checked: _vm.isVatExempt,
              label: _vm.$t.__(
                "CompanyInformation.legal_information.vat_exempt_label"
              )
            },
            on: { change: _vm.handleTaxExemptionChange }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.legal_information.legal_status_label"
            ),
            orientation: "horizontal"
          }
        },
        [
          _c(
            "CompassSelect",
            {
              model: {
                value: _vm.legalStatus,
                callback: function($$v) {
                  _vm.legalStatus = $$v
                },
                expression: "legalStatus"
              }
            },
            _vm._l(_vm.companyLegalStatusList, function(item) {
              return _c("CompassDropdownSelectOption", {
                key: item,
                attrs: { label: item, value: item }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.legal_information.share_capital_label"
            ),
            orientation: "horizontal"
          }
        },
        [
          _c("CompassInput", {
            scopedSlots: _vm._u(
              [
                _vm.showCurrencyLeft
                  ? {
                      key: "prefix",
                      fn: function() {
                        return [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.numformat.currencysymbol) +
                              "\n            "
                          )
                        ]
                      },
                      proxy: true
                    }
                  : null,
                _vm.showCurrencyRight
                  ? {
                      key: "suffix",
                      fn: function() {
                        return [
                          _vm._v(
                            "\n                " +
                              _vm._s(_vm.numformat.currencysymbol) +
                              "\n            "
                          )
                        ]
                      },
                      proxy: true
                    }
                  : null
              ],
              null,
              true
            ),
            model: {
              value: _vm.shareCapital,
              callback: function($$v) {
                _vm.shareCapital = $$v
              },
              expression: "shareCapital"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__(
              "CompanyInformation.legal_information.naf_code_label"
            ),
            orientation: "horizontal"
          }
        },
        [
          _c("CompassInput", {
            model: {
              value: _vm.naf,
              callback: function($$v) {
                _vm.naf = $$v
              },
              expression: "naf"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "CompassFormItem",
        {
          attrs: {
            label: _vm.$t.__("CompanyInformation.legal_information.rcs_label"),
            orientation: "horizontal"
          }
        },
        [
          _c("CompassInput", {
            model: {
              value: _vm.rcs,
              callback: function($$v) {
                _vm.rcs = $$v
              },
              expression: "rcs"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("CompassButton", {
        staticClass: "company-information-form__save-button",
        attrs: {
          label: _vm.$t.__("CompanyInformation.legal_information.save_button")
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }